module.exports = __webpack_public_path__ + "img/title9.09a1d735.png";